const getDropdownOptionText = (options, value) => {
  if (!value) {
    return null;
  }

  const selectedOption = options.find(opt => opt.value === value);

  return selectedOption ? selectedOption.label : value;
};

export default getDropdownOptionText;
